import { render, staticRenderFns } from "./productosConErrorModal.vue?vue&type=template&id=49e5b72a&"
import script from "./productosConErrorModal.vue?vue&type=script&lang=js&"
export * from "./productosConErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable})
